import type { Theme } from '@mui/material';
import { alpha, darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import type { ColorButtonSize } from './colorButton.types';

export const COLOR_DOT_SIZE: Record<ColorButtonSize, number> = {
  sm: 10,
  lg: 24,
};

const RING_GAP: Record<ColorButtonSize, number> = {
  sm: 3,
  lg: 2,
};
const RING_WIDTH = 1;
const DOT_BORDER_DARKEN = 0.15;
const NEUTRAL_BORDER_OPACITY = 0.1;

export const getDotBorderColor = (theme: Theme, hexcode?: string) => {
  const neutralBorderColor = alpha(theme.palette.common.black, NEUTRAL_BORDER_OPACITY);

  if (!hexcode) {
    return neutralBorderColor;
  }

  try {
    return darken(hexcode, DOT_BORDER_DARKEN);
  } catch {
    return neutralBorderColor;
  }
};

export const encodeImageUrl = (imageUrl: string) => {
  try {
    return encodeURI(decodeURI(imageUrl));
  } catch {
    return encodeURI(imageUrl);
  }
};

interface ColorButtonStylesParams {
  dotBorderColor: string;
  size: ColorButtonSize;
}

export const useColorButtonStyles = makeStyles<ColorButtonStylesParams>()(
  (theme, { dotBorderColor, size }) => ({
    button: {
      boxSizing: 'border-box',
      flexShrink: 0,
      padding: `${RING_GAP[size]}px`,
      borderRadius: theme.shape.borderRadiusFull,
      border: `${RING_WIDTH}px solid transparent`,
      transition: theme.transitions.create('border-color', {
        duration: theme.transitions.duration.shorter,
      }),
      '&:hover': {
        borderColor: theme.palette.action.active,
      },
    },
    buttonSelected: {
      borderColor: theme.palette.accent.main,
      '&:hover': {
        borderColor: theme.palette.accent.main,
      },
    },
    dot: {
      boxSizing: 'border-box',
      flexShrink: 0,
      width: COLOR_DOT_SIZE[size],
      height: COLOR_DOT_SIZE[size],
      borderRadius: theme.shape.borderRadiusFull,
      border: `1px solid ${dotBorderColor}`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
  }),
);
